export const REPORTS_SET_DATA_LOADING_STATE = 'REPORTS_SET_DATA_LOADING_STATE';
export const REPORTS_SET_REQUEST_LOADING_STATE = 'REPORTS_SET_REQUEST_LOADING_STATE';
export const REPORTS_SET_ERROR = 'REPORTS_SET_ERROR';
export const REPORTS_RESET_ERROR = 'REPORTS_RESET_ERROR';
export const REPORTS_SET_REPORTS = 'REPORTS_SET_REPORTS';
export const REPORTS_SET_NEW_REPORT = 'REPORTS_SET_NEW_REPORT';
export const REPORTS_SET_GROUP_ID = 'REPORTS_SET_GROUP_ID';
export const REPORTS_SET_REMOVE_ITEM_FROM_STATE = 'REPORTS_SET_REMOVE_ITEM_FROM_STATE';
